import Vue from 'vue'
import Axios from 'axios'
import ElementUI from 'element-ui'
import qs from 'qs'
import vue from '@/main'
import baseUrl from '@/base-url'

// 服务端baseURL
// Axios.defaults.baseURL = 'http://wxapp.mianke.me:2001/hj_cloud/web'
// Axios.defaults.baseURL = 'http://localhost/hj_cloud/web'
Axios.defaults.baseURL = baseUrl

const axios = Axios.create({
    timeout: 30 * 1000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

// http request 拦截器
// 每次请求都为http头增加AccessToken字段，其内容为user的access_token
axios.interceptors.request.use(
    config => {
        // Do something before request is sent
        if (vue.$store.state.user.access_token) {
            config.headers['Access-Token'] = `${vue.$store.state.user.access_token}`
        }
        if (config.headers['Content-Type'] !== 'text/plain' && config.headers['Content-Type'] !== 'application/json') {
            config.data = qs.stringify(config.data)
        }
        console.log('axios http request-->', config)
        return config
    },
    error => {
        // Do something with request error
        console.log('axios http request error-->', error)
        return Promise.reject(error)
    }
)

// http response 拦截器
// 针对响应代码确认跳转到对应页面
axios.interceptors.response.use(
    response => {
        // Do something with response data
        console.log('axios http response-->', response)
        if (response.status !== 200) {
            ElementUI.Notification.error({title: '系统错误', message: response.data.toString(), duration: 0})
        }
        if (response.data.code && response.data.code === -1) {
            vue.$router.push('/passport/login', e => {
                vue.$router.go(0)
            })
        }
        return response.data
    },
    error => {
        // Do something with response error
        console.log('axios http response error-->', error)
        ElementUI.Notification.error({title: '网络连接出错', message: error.message, duration: 0})
        return Promise.reject(error)
    }
)

Vue.use({
    // eslint-disable-next-line no-unused-vars
    install(Vue, options) {
        Vue.prototype.$request = axios
    }
})

export default axios
